import { useEffect } from 'react';

import Icon from '../../Icon/Icon';

import type { IconName } from '../../Icon/Icon';
import type { FC } from 'react';

export interface HackIconProps {
  onUnmount: () => void;
  onMount?: () => void;
  icon: IconName;
}

export const HackIcon: FC<HackIconProps> = ({ onUnmount, onMount, icon }) => {
  useEffect(() => {
    onMount && onMount();
    return () => {
      onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Icon icon={icon} />;
};
